export class StatusEventGroupPagePayload {
  id: number;
  name: string;
  machineGroupId?: number;
  menuItemId?: string;

  constructor({id, machineGroupId, name, menuItemId}: StatusEventGroupPagePayload) {
    this.id = id || 0;
    this.name = name || '';
    this.machineGroupId = machineGroupId || 0;
    this.menuItemId = menuItemId || '-1';
  }
}
